import styled from "styled-components";
import {LiveCasinoGridItemWrapperDefaultBox} from "./live-casino-grid-item-wrapper.default.box";

export const LiveCasinoGridItemWrapperCasino777Box = styled(LiveCasinoGridItemWrapperDefaultBox)`
    box-shadow: 0 0 5px ${props => props.theme.colors.buttonLight};
`;
